export const CARRIER_CODE_UPS = "UP";
export const CARRIER_CODE_FEDEX = "FX";

export function getCarrierLabel(carrierShippingMethod?: string | null): string {
  if (!carrierShippingMethod) {
    return "";
  }
  const code = carrierShippingMethod.toUpperCase();
  if (code.includes(CARRIER_CODE_UPS)) {
    return "UPS";
  }
  if (code.includes(CARRIER_CODE_FEDEX)) {
    return "Fedex";
  }
  return "";
}

/** Falls back to the carrier label when the D365 shipping method has no description. */
export function getShippingMethodDisplay(
  shippingMethodName?: string | null,
  carrierShippingMethod?: string | null
): string {
  return shippingMethodName?.trim()
    ? shippingMethodName
    : getCarrierLabel(carrierShippingMethod);
}

export function isUpsCarrier(
  carrierShippingMethod?: string | null,
  shippingMethod?: string | null
): boolean {
  return (carrierShippingMethod ?? shippingMethod ?? "")
    .toUpperCase()
    .includes(CARRIER_CODE_UPS);
}

export function isFedexCarrier(
  carrierShippingMethod?: string | null,
  shippingMethod?: string | null
): boolean {
  return (carrierShippingMethod ?? shippingMethod ?? "")
    .toUpperCase()
    .includes(CARRIER_CODE_FEDEX);
}
